import { atom } from 'jotai';

export const activeHomeTabAtom = atom<string>('');
